module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/GB_T29490-2013.335c85a3.png";